import React from "react";
import WidthContext from "../WidthContext";

export default (Com: Function) => (props: any) => {
  return (
    <WidthContext.Consumer>
      {width => <Com width={width} {...props} />}
    </WidthContext.Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/HOCs/getWidthContext.tsx